module.exports = __webpack_public_path__ + "img/logo.f9f59b92.png";